import styled from 'styled-components';

export const StyledTitle = styled.h1`
  font-size: 2.4rem;
  color: ${({ theme }) => theme.colors.grey[100]};
  margin-bottom: 0.6rem;
`;
